import * as React from "react";
import Grid from "@mui/material/Grid"; 
import { CmpTypographyField } from "../../Component/Common/ToolBox/ToolBox"; 
export const BinTrnasferDetailCard = ({
  SrNo='',
  BinName='',  
  ItemCode='', 
  ItemName='',
  Qty='',
  UnitName='',
  BaseQty='',
  onClick='',
}) => {
  let xsLabel = 3; 
  let xsColon =0.5;
  let xsValue =8.5; 

  let mdLabel = 3; 
  let mdColon = 0.5;
  let mdValue = 8.5; 
  return (
    <Grid
      container
      spacing={0}
      rowSpacing={0}
      sx={{
        // border: "1px solid black",
        borderWidth: "1px 1px 1px 5px",
        borderStyle: "solid solid solid solid",
        borderRadius: "0px 10px 10px 0px",
        padding: "12px 8px",
        marginTop: "5px",
        borderColor: "#0d73bb",
         
        // border-width: 1px 1px 1px 3px;
        // border-style: double double double solid;
      }}
      columns={{ xs: 12, sm: 12, md: 12 }}
      onClick={onClick}
      className="PickingHeadCard"
    >
      <Grid item xs={xsLabel} md={mdLabel}>
        <CmpTypographyField xcomponent={"span"} xText={"Sr.No"} />
      </Grid>
      <Grid item xs={xsColon} md={mdColon}>
        <CmpTypographyField xcomponent={"span"} xText={":"} />
      </Grid>
      <Grid item xs={xsValue} md={mdValue}>
        <CmpTypographyField xcomponent={"span"} xText={SrNo} />
      </Grid>
      <Grid item xs={xsLabel} md={mdLabel}>
        <CmpTypographyField xcomponent={"span"} xText={"Bin.Name"} />
      </Grid>
      <Grid item xs={xsColon} md={mdColon}>
        <CmpTypographyField xcomponent={"span"} xText={":"} />
      </Grid>
      <Grid item xs={xsValue} md={mdValue}>
        <CmpTypographyField xcomponent={"span"} xText={BinName} />
      </Grid>
      <Grid item xs={xsLabel} md={mdLabel}>
        <CmpTypographyField xcomponent={"span"} xText={"Item.Code"} />
      </Grid>
      <Grid item xs={xsColon} md={mdColon}>
        <CmpTypographyField xcomponent={"span"} xText={":"} />
      </Grid>
      <Grid item xs={xsValue} md={mdValue}>
        <CmpTypographyField xcomponent={"span"} xText={ItemCode} />
      </Grid>

     
      <Grid item xs={xsLabel} md={mdLabel}>
        <CmpTypographyField xcomponent={"span"} xText={"Item.Name"} />
      </Grid>
      <Grid item xs={xsColon} md={mdColon}>
        <CmpTypographyField xcomponent={"span"} xText={":"} />
      </Grid>
      <Grid item xs={xsValue} md={mdValue}>
        <CmpTypographyField xcomponent={"span"} xText={ItemName} />
      </Grid>     

      <Grid item xs={xsLabel} md={mdLabel}>
        <CmpTypographyField xcomponent={"span"} xText={"Qty"} />
      </Grid>
      <Grid item xs={xsColon} md={mdColon}>
        <CmpTypographyField xcomponent={"span"} xText={":"} />
      </Grid>
      <Grid item xs={xsValue} md={xsValue}>
        <CmpTypographyField xcomponent={"span"} xText={Qty} />
      </Grid>
      <Grid item xs={xsLabel} md={mdLabel}>
        <CmpTypographyField xcomponent={"span"} xText={"Unit.Name"} />
      </Grid>
      <Grid item xs={xsColon} md={mdColon}>
        <CmpTypographyField xcomponent={"span"} xText={":"} />
      </Grid>
      <Grid item xs={xsValue} md={xsValue}>
        <CmpTypographyField xcomponent={"span"} xText={UnitName} />
      </Grid>
      <Grid item xs={xsLabel} md={mdLabel}>
        <CmpTypographyField xcomponent={"span"} xText={"Base.Qtye"} />
      </Grid>
      <Grid item xs={xsColon} md={mdColon}>
        <CmpTypographyField xcomponent={"span"} xText={":"} />
      </Grid>
      <Grid item xs={xsValue} md={xsValue}>
        <CmpTypographyField xcomponent={"span"} xText={BaseQty} />
      </Grid>
 

     
     
    </Grid>
  );
};
